// @flow
import _ from 'underscore';

export class UserError {
  constructor(message: string) {
    this._message = message;
  }

  _message: string;

  get message(): string {
    return this._message;
  }

  set message(message: string) {
    this._message = message;
  }
}

export default class User {
  static build(token) {
    const userProperties = token.userDetails.properties || {};
    const availableProducts = token.products;

    const account = getUserAccount(token);
    const accountName = account.name || '';
    const accountProperties = account.properties || [];

    const teamId = accountProperties.find(property => property.key === 'team_id');
    const leagueId = accountProperties.find(property => property.key === 'league_id');

    const isConsumer = accountProperties.find(property => property.key === 'is_consumer');
    const teamName = accountProperties.find(property => property.key === 'team_name' || property.key === 'name');
    const teamNick = accountProperties.find(property => property.key === 'team_nick');
    const primaryColor = accountProperties.find(property => property.key === 'primary_color');
    const secondaryColor = accountProperties.find(property => property.key === 'secondary_color');
    const teamLogo = accountProperties.find(property => property.key === 'team_logo' || property.key === 'logo');
    const teamAbrv = accountProperties.find(property => property.key === 'team_abbr');

    const additionalLeagues = accountProperties.find(property => property.key === 'additional_leagues');


    if (!account.id) {
      throw (new UserError('Could not determine primary account'));
    }

    return {
      ...userProperties,
      teamId: teamId ? teamId.value : null,
      leagueId: leagueId ? leagueId.value : null,
      userLeagues: getUserLeagues(leagueId, additionalLeagues),
      accountId: account.id,
      userId: token.userDetails.userId,
      displayName: token.userDetails.displayName,
      isSuperAdmin: token.userDetails.superAdmin,
      isImpersonating: !!token.impersonatedBy,
      roles: token.roles,
      hasAdvancedStats: false,
      availableProducts,
      isConsumer: isConsumer ? isConsumer.value : false,
      teamName: teamName ? teamName.value : accountName,
      teamNick: teamNick ? teamNick.value : null,
      primaryColor: primaryColor ? primaryColor.value : '000',
      secondaryColor: secondaryColor ? secondaryColor.value : '000',
      teamLogo: teamLogo ? teamLogo.value :
        'https://download.fastmodeltechnologies.com/FSimages/logos/default_white_logo.png',
      teamAbrv: teamAbrv ? teamAbrv.value : null,
    };
  }
}

const getUserLeagues = (leagueAccountProperty, extraLeaguesAccountProperty) => {
  if (extraLeaguesAccountProperty) {
    return _.uniq([ leagueAccountProperty.value ].concat(extraLeaguesAccountProperty.value.split(';')));
  } else if (leagueAccountProperty) {
    return [ leagueAccountProperty.value ];
  }
  return null;
};

const getUserAccount = (token) => {
  return _.values(token.products)[ 0 ][ 0 ].account;
};